import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/Home';
import Navigation from './components/Navigation'; // Certifique-se do casing
import Footer from './components/Footer';
import './App.css';


const App = () => {
  return (
    <Router>
      <div className="app-container">
        <Navigation />
        <main className="app-container ">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

// Componente para página não encontrada (adicione este novo componente)
const NotFoundPage = () => {
  return (
    <div className="text-center py-5">
      <h1>404 - Página Não Encontrada</h1>
      <p>A página que você está procurando não existe.</p>
    </div>
  );
};

export default App;